export class FiltrosRepComercial{
   
   Usuario : string ='';
   Estado: string = '';
   Tipo: string = 'factura_negociada';
   idEmpresa_Factor: string = '7';

}